import Vue, {ComponentOptions, VueConstructor} from "vue";
import allowedModules from "@/views/PageProfile/allowedModules";
import {getComponentName} from "@/lib/helpers/componentViewController";

export interface ProfileComponentData {
  component: VueConstructor<Vue> | ComponentOptions<Vue>;
  right?: boolean;
  ruleName?: string;
  ruleKey?: string;
}

export const filterComponents = (componentList: ProfileComponentData[]) => {
  return componentList.filter(
    componentData => !!allowedModules.find(moduleName => getComponentName(componentData.component) === moduleName)
  );
};
